

(function($) 
{
    var $flexContent = $('#acf-lm_layouts')

    if (!$flexContent.length) return

    function handleCols($block)
    {       
        $block.find('input[type=radio]')
            .on('change', function() { setCol($(this)) })
    }

    function setCol($radio) 
    {
        var width

        // 1:|a|  2:|a|b|  3:|a|b|c|  4:|a|b|c|d|  5:|a|bb|  6:|aa|b|  7:|a|bbb|  8:|aaa|b|
        switch ($radio.val())
        {
            case '5' : width = '33.3333333%';   break;
            case '6' : width = '66.6666666%';   break;
            case '7' : width = '25%';           break;
            case '8' : width = '75%';           break;
            default  : width = 'auto';          break;
        }

        setTimeout(function() { 
            $radio.parents('.layout')
                .find('.acf-table tr > *:first-child')
                .css('width', width)
        }, 10)        
    }


    acf.add_action('load', function( $el ) {
        $.each($flexContent.find('.layout'), function() {

            handleCols($(this))
            setCol($(this).find('input[type=radio]:checked'))        
        })
    })

    acf.addAction('append', function($el) {
        handleCols($el)
    })

})(jQuery)